export default {"src":"/_next/static/media/boundary-logo-mark_on-light.580c4e8e.svg","height":72,"width":40,"blurWidth":0,"blurHeight":0};